export default __webpack_public_path__ + "acfb5f4d09dba239869e4e1a9db2f1d1.svg";